import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); setTimeout(() => nav("/portal"), 2500); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch { /* keep polling */ }
      if (tries++ < 8) setTimeout(poll, 1500); else setState("timeout");
    };
    poll();
  }, [sessionId, nav]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#fdfbf7] flex items-center justify-center p-6">
      <div className="text-center max-w-md" data-testid="payment-success-page">
        {state === "checking" && <><Loader2 size={48} className="animate-spin text-[#d4af37] mx-auto" /><p className="mt-5 text-lg">Confirming your payment…</p></>}
        {state === "paid" && <><CheckCircle2 size={56} className="text-[#d4af37] mx-auto" /><h1 className="font-display text-4xl mt-5">Payment confirmed</h1><p className="text-[#cfcabf] mt-3">Thank you. Redirecting to your portal…</p></>}
        {(state === "error" || state === "timeout") && <><XCircle size={56} className="text-red-400 mx-auto" /><h1 className="font-display text-3xl mt-5">We couldn't confirm your payment</h1><p className="text-[#cfcabf] mt-3">If you were charged it will appear shortly. You can check your portal.</p><Link to="/portal" className="btn-gold inline-block mt-5 px-6 py-3 rounded-sm">Go to portal</Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#fdfbf7] flex items-center justify-center p-6">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <XCircle size={56} className="text-[#cfcabf] mx-auto" />
        <h1 className="font-display text-4xl mt-5">Payment cancelled</h1>
        <p className="text-[#cfcabf] mt-3">No charge was made. You can try again from your portal anytime.</p>
        <Link to="/portal" className="btn-gold inline-block mt-5 px-6 py-3 rounded-sm">Back to portal</Link>
      </div>
    </div>
  );
}
